const locale = {
	CLEANING: 'Почистване',
    CLEANING_SESSIONS: 'История на почиствания',
    EXPRESS_CLEANING: 'Експресно почистване',
    NO_EXPRESS_CLEANING_ROOMS: 'В момента няма стаи маркирани за експресно почистване',
    CHECKOUT_CLEANING: 'Почистване при освобождаване',
    NO_CHECKOUT_CLEANING_ROOMS: 'В момента няма стаи маркирани за почистване при освобождаване',
    DIRTY_ROOMS: 'Непочистени стаи',
    CLEANED_ROOMS: 'Почистени стаи',
    NO_DIRTY_ROOMS: 'За момента няма зададени стаи за почистване',
    NO_CLEANED_ROOMS: 'За момента няма почистени стаи',
    CURRENTLY_CLEANING: 'В процес на почистване',
    NO_CURRENTLY_CLEANING_ROOMS: 'В момента не се почиства никоя стая',
    
    // Notification translations
    ROOM_ASSIGNED_TITLE: 'Ново назначение на стая',
    ROOM_ASSIGNED_BODY: 'Назначени са ви {{count}} стая(и): {{rooms}}',
    ROOM_REASSIGNED_FROM_TITLE: 'Преназначени стаи',
    ROOM_REASSIGNED_FROM_BODY: '{{count}} стая(и) преназначени на {{newCleaner}}: {{rooms}}',
    ROOM_REASSIGNED_TO_TITLE: 'Ново назначение на стая',
    ROOM_REASSIGNED_TO_BODY: '{{count}} стая(и) преназначени от {{oldCleaner}}: {{rooms}}',
    ROOM_ASSIGNMENT_REMINDER_TITLE: 'Напомняне за назначение на стая',
    ROOM_ASSIGNMENT_REMINDER_BODY: 'Имате {{count}} стая(и) за почистване днес: {{rooms}}',
    ROOM_ASSIGNMENT_UPDATE_TITLE: 'Актуализиране на назначение',
    ROOM_ASSIGNMENT_UPDATE_BODY: 'Вашите назначения за стаи са актуализирани: {{rooms}}',

    SELECT_A_FLOOR: 'Изберете етаж',
    ALL: 'Всички етажи',
    FLOOR_NUMBER: "Етаж {{number}}",

    Clean: 'Почистена',
    Dirty: 'Непочистена',
    Cleaning: 'Почиства се',
    Express : 'Експресно почистване',
    Maintenance: 'Поддръжка',
    Inspection: 'Инспекция',
    Completed: 'Завършена',
    Cancelled: 'Отменена',
    Paused: 'Пауза',
    Reported: 'Докладвана',
    'Awaiting Fixing': 'Чака ремонт',
    Fixing: 'Ремонтира се',
    Fixed: 'Ремонтирана',
    Pending: 'Чакаща',
    Approved: 'Одобрена',
    Rejected: 'Отхвърлена',
    Assigned: 'Назначена',
    Skipped: 'Пропусната',
    Reassigned: 'Пренаназначена',
    CANCEL_THE_REQUEST: 'Отмяна',
    MARK_AS_DIRTY: 'Маркирай като непочистена',
    START_CLEANING: 'Започни почистване',
    CHECK: 'Провери',
    ROOM_NUMBER: 'Стая номер:',
    VIEW_CLEANING: 'Преглед на почистване',
    ELAPSED_TIME: 'Време на почистване',

    MAINTENANCE: 'Техническа поддръжка',
    CLOSE: 'Затвори',
    CONFIRM: 'Потвърди',
    SUCCESS_MAINTENANCE: 'Заявката за техническа поддръжка е изпратена успешно',
    CHOOSE_MAINTENANCE: ' Избери какво има нужда да бъде подменено или ремонтира в съответната стая',

    ADD_COMMENT: 'Добави коментар' ,
    END_CLEANING: 'Завърши почистване',
    HISTORY: 'История',
    NO_HISTORY: 'Няма история',
    FULL_HISTORY: 'Пълна история',
    EXISTING_EVALUATION: 'Текуща оценка',
    SUBMIT_EVALUATION: 'Изпрати оценка',
    RATING: 'Оценка',
    RATING_COMMENTS: 'Коментар към оценката',
    REASSIGNMENT_REASON: 'Причина за преназначаване',
    REASSIGNMENT_REASON_PLACEHOLDER: 'Обяснете защо това почистване трябва да бъде преназначено...',
    REASSIGNMENT_REASON_REQUIRED: 'Причината е задължителна при преназначаване',
    REASSIGNMENT_SUBMITTED_SUCCESS: 'Преназначението е успешно!',
    REASON_FOR_REASSIGNMENT: 'Причина за преназначаване',
    REASSIGNED: 'Маркирана за повторно почистване',
    NOT_REASSIGNED: 'Не е маркирана за повторно почистване',
    REASSIGN_CLEANING: 'Върни за повторно почистване',
    SUBMIT_REASSIGNMENT: 'Върни за повторно почистване',
    REASSIGNED_DUE_TO: 'Преназначена поради:',
    ROOM_RETURNED_FOR_RECLEANING: 'Стаята е върната за повторно почистване',
    MAIN_CLEANER_FEEDBACK: 'Коментар от Главен Камериер',
    RETURNED: 'Върната',
    RETURNED_ROOM_TOOLTIP: 'Тази стая е била върната за повторно почистване днес. Започнете почистване, за да видите коментара от Главния Камериер.',

    ALREADY_CLEANING: "Вече почистваш",
    ANOTHER_CLEANER_TIP: "Друг почиства тази стая в момента",
    ALREADY_CLEANING_TIP: "В момента почистваш друга стая.",
    ROOM_ALREADY_CLEAN: "Стаята вече е почистена",

    // Cleaning Sessions Page
    SESSION_NOTES: 'Бележка за сесията',
    NO_NOTES_AVAILABLE: 'Няма налични бележки',
    NO_SESSIONS_FOUND: 'Няма намерени сесии за почистване',
    SEARCH_SESSIONS: 'Търсене по стая, почистващ служител или бележки...',
    ROOM: 'Стая',
    FLOOR: 'Етаж', 
    CLEANER: 'Почистващ служител',
    START_TIME: 'Начало',
    END_TIME: 'Край',
    DURATION: 'Продължителност',
    STATUS: 'Статус',
    LOADING: 'Зареждане...',
    NO_COMMENTS: 'Няма бележка за тази сесия',
    
    // Cleaning Checklist
    CLEANING_CHECKLIST: 'Списък за почистване',
    NO_CHECKLIST_AVAILABLE: 'Няма наличен списък за проверка за този тип стая',
    COMPLETION_PROGRESS: 'Прогрес',
    REQUIRED_ITEMS: 'Задължителни елементи',
    REQUIRED: 'Задължително',
    ADD_NOTES: 'Добави бележка',
    OPTIONAL_NOTES_PLACEHOLDER: 'Добавете допълнителна бележка за тази задача...',
    COMPLETED_AT: 'Приключена в',
    ALL_REQUIRED_ITEMS_COMPLETED: 'Всички задължителни елементи са завършени!',
    LEAVE_COMMENT: 'Остави коментар',
    CHECKLIST_PROGRESS: 'Завършени задачи',
    CHECKLIST_ITEMS: 'Списък със задачи',
    NO_CHECKLIST: 'Няма списък',
    NOTES: 'Бележка:',
    STANDARD_ROOM: 'Стандартна стая',

    // Checklist category options
    CHECKLIST_BEDROOM: 'Спалня',
    CHECKLIST_BATHROOM: 'Баня',
    CHECKLIST_BOTH: 'И двете',
    CHECKLIST_GENERAL: 'Общи',

    // Main Cleaner specific translations
    ROOM_STATUS_INFO: 'Информация за статуса на стаята',
    SUPERVISOR_FEEDBACK: 'Коментар от супервайзор',
    SUPERVISOR_COMMENT_PLACEHOLDER: 'Оставете вашия коментар за статуса на почистването на тази стая...',
    SUBMIT_FEEDBACK: 'Изпрати коментар',
    SUBMITTING: 'Изпращане...',
    NO_SUPERVISOR_FEEDBACK: 'Няма коментар от супервайзор',
    LATEST_CLEANING_SESSION: 'Последна сесия за почистване',
    NO_CLEANING_SESSION_FOUND: 'Все още стаята не е била почистена за деня',
    NO_CLEANING_SESSION_TODAY: 'Няма сесии за почистване на тази стая днес',
    UNKNOWN_USER: 'Неизвестен потребител',
    EXISTING_SUPERVISOR_COMMENT: 'Предишен коментар от супервайзор',
    ASSIGNED_TO: 'Назначена на',
    NOT_ASSIGNED: 'Не е назначена',
    ESTIMATED_TIME: 'Очаквано време',
    CLEANING_DATE: 'Дата на почистване',

 // Main Cleaner No Room Access
 NO_ROOMS_ASSIGNED_TITLE: 'Няма назначени стаи',
 NO_ROOMS_ASSIGNED_DESCRIPTION: 'Все още нямате достъп до стаи. Моля, свържете се с вашия администратор, за да ви назначи стаи.',
 CONTACT_ADMINISTRATOR: 'Свържете се с администратор',

 // Auto-completion messages
 AUTO_COMPLETED_MIDNIGHT: 'Автоматично завършено: Сесията премина полунощ без ръчно завършване.',

    // Rating and Reassignment translations
    RATE_CLEANING: 'Оцени това почистване',
    CLEANING_RATING: 'Качество на почистването',
    RATING_COMMENT: 'Допълнителни коментари (по желание)',
    RATING_COMMENT_PLACEHOLDER: 'Добавете специфични коментари относно качеството на почистването...',

    REASSIGN_TO_ORIGINAL_CLEANER: 'Преназначи на първоначалния почистващ',
    SUBMIT_RATING_AND_REASSIGNMENT: 'Изпрати оценка и преназначаване',
    SUBMIT_RATING_REASSIGNMENT: 'Изпрати оценка и преназначаване',
    SUBMIT_RATING: 'Изпрати оценка',
    RATING_SAVED_SUCCESS: 'Оценката е запазена успешно',
    RATING_SUBMITTED_SUCCESS: 'Оценката и коментарът са изпратени успешно!',
    RATING_SUBMIT_ERROR: 'Неуспешно изпращане на оценката. Моля, опитайте отново.',
    RATING_AND_REASSIGNMENT_SUCCESS: 'Оценката е запазена и стаята е преназначена успешно',
    RATING_SAVE_FAILED: 'Неуспешно запазване на оценката. Моля, опитайте отново.',
    ALREADY_EVALUATED: 'Тази сесия за почистване вече е оценена',

    // Room Types
    SINGLE_ROOM: 'Единична стая',
    DOUBLE_ROOM: 'Двойна стая',
    TWIN_ROOM: 'Стая с две единични легла',
    TRIPLE_ROOM: 'Тройна стая',
    QUEEN_ROOM: 'Стая с голямо легло',
    KING_ROOM: 'Стая с кралско легло',
    STUDIO_ROOM: 'Студио',
    SUITE: 'Апартамент',
    JUNIOR_SUITE: 'Junior апартамент',
    PRESIDENTIAL_SUITE: 'Президентски апартамент',

    // Checklist access control
    CHECKLIST_ACCESS_DENIED: 'Достъпът до списъка е отказан',
    CHECKLIST_ACCESS_DENIED_MESSAGE: 'Преглеждането на списъка е деактивирано за Камериери. Моля, свържете се с вашия администратор за помощ.',
};

export default locale;
